import APIClient from '../../Services/AxiosClient';
import { URL_ENDPOINTS } from '../../Utils/EndPoints';

export const fetchTypeAhead = async (queryPayloads: any, callback: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.SEARCH?.TYPEAHEAD,
      method: 'get',
      query: queryPayloads,
    });
    response && callback && callback(response);
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    callback && callback(null);
    return null;
  }
};
export const fetchRecentSearch = async (queryPayloads: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.SEARCH?.GETRECENT,
      method: 'post',
      data: queryPayloads,
    });
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
export const fetchFavoriteSearch = async (queryPayloads: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.SEARCH?.GETFAVORITE,
      method: 'post',
      data: queryPayloads,
    });
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
export const modifyFavoriteSearch = async (payload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.SEARCH?.UPDATEFAVORITE,
      method: 'put',
      data: payload?.queryPayloads,
    });
    payload?.callback?.({ ...response });
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
export const fetchUserWatchedLoads = async (queryPayloads: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.SEARCH?.GETWATCHLOADS,
      method: 'post',
      data: queryPayloads,
    });
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
export const modifyWatchedLoads = async (payload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.SEARCH?.UPDATEWATCHED,
      method: 'put',
      data: payload?.queryPayloads,
    });
    response && payload?.callback && payload?.callback({ ...response });
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
export const fetchSearchLoads = async (queryPayloads: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.SEARCH?.GETSEARCHLOADS,
      method: 'post',
      data: queryPayloads,
    });
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
export const fetchLoadById = async (queryPayloads: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.SEARCH?.GETLOADBYID,
      method: 'post',
      data: queryPayloads,
    });
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
export const postBookLoad = async (queryPayloads: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.SEARCH?.POSTBOOKLOAD,
      method: 'post',
      data: queryPayloads,
    });
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
